/**
 * In-memory holder for the auth tokens (LT-2998).
 * Tokens must never be written to localStorage — they live here (and in Redux)
 * for the lifetime of the tab, and are re-fetched from GET /session on reload.
 */

interface Tokens {
    accessToken?: string;
    idToken?: string;
}

let tokens: Tokens = {};

export function setTokens(next: Tokens): void {
    tokens = {
        accessToken: next.accessToken ?? tokens.accessToken,
        idToken: next.idToken ?? tokens.idToken,
    };
}

export function getTokens(): Tokens {
    return { ...tokens };
}

export function clearTokens(): void {
    tokens = {};
}
